// @flow
import { path } from 'ramda'

import { getChannelCountries } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_CHANNEL_COUNTRIES = 'channels/FETCH_COUNTRIES'

const fetchChannelCountriesAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_CHANNEL_COUNTRIES,
    payload: getChannelCountries(publicApi, serviceSpec),
    meta: {
      ttl,
    },
  })
}

// eslint-disable-next-line complexity
export const fetchChannelCountries = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchChannelCountriesAction(serviceSpec))

  const state = getState()
  const expires = path(['channelCountries', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchChannelCountriesAction(serviceSpec))
}
